import store from '@/store'
import DictUtil from '@/utils/dict.js'

export default (value) => {
  if (!value) {
    return '-'
  }

  let data = store.state.dictData[DictUtil.GROUP.caseType.value]
  if (!data || !data.length) {
    return '-'
  }

  let labelArr = []
  let item = getCaseType(value, data)
  while (item) {
    labelArr.push(item.label)
    item = getCaseType(item.description, data)
  }

  return labelArr && labelArr.length ? labelArr.reverse().join(' ') : '-'
}

const getCaseType = (value, data) => {
  if (!value) {
    return null
  }
  value = String(value)
  if (value.indexOf('_') !== -1) {
    value = value.substr(value.indexOf('_') + 1, value.length)
  }
  if (data && data.length) {
    let item = data.find(each => each.value === value)
    return item || null
  }
  return null
}



// WEBPACK FOOTER //
// ./src/filters/caseTypeFilter.js